import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";
import BsyDialog from '../BsyDialog';
import AlertListSelectAppPopupPane from './selectAppPopupPane'

class AlertListSelectApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appid: props.appid,
            formid: props.formid,
            name: props.name,
            icon: props.icon,
            hasCoop: props.hasCoop,
            type: props.type,
        }
    }

    cancelClick = () => {
        this.props.onRemoveRoot();
        // document.getElementsByClassName("BsyAlertListDetail")[0].remove()
    }

    componentDidMount() {
        this.getAppList();
    }

    getAppList = () => {
        React.axios('/corp/outsider/share/info', {
            group_id: this.state.group_id
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                const newState = {
                    ...this.state,
                    ...res.data
                }
                this.setState(newState)
            })
        }).catch(res => {

        })
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const newState = {
            ...this.state,
            ...nextProps,
        }
        this.setState(newState)
    }

    getPopupValue = (val) => {
        this.value = { ...val };
    }

    onChange = () => {
        BsyDialog({
            title: React.language("outsider.miniapp.seting.launcher"),
            height: 540,
            width: 720,
            customText: React.language('outsider.miniapp.seting.launcher.clear'),
            onCustom: () => {
                const newState = {
                    ...this.state,
                    ...{
                        appid: null,
                        formid: null,
                        name: null,
                        icon: null,
                    },
                }
                this.setState(newState, () => {
                    if (this.props.onStopEdit) {
                        this.props.onStopEdit({
                            appid: newState.appid,
                            formid: newState.formid,
                            name: newState.name,
                            icon: newState.icon,
                            hasCoop:newState.hasCoop,
                            type:newState.type,
                        })
                    }
                })
            },
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AlertListSelectAppPopupPane
                    appid={this.state.appid}
                    formid={this.state.formid}
                    getValue={this.getPopupValue} />
            },
            onOk: () => {

                if (!this.value) {
                    return false
                }

                const newState = {
                    ...this.state,
                    ...this.value,
                }
                this.setState(newState, () => {
                    if (this.props.onStopEdit) {
                        this.props.onStopEdit({
                            appid: newState.appid,
                            formid: newState.formid,
                            name: newState.name,
                            icon: newState.icon,
                            hasCoop:newState.hasCoop,
                            type:newState.type,
                        })
                    }
                })
            }
        })


    }

    render() {

        const { name, icon, type, hasCoop } = this.state;

        return (
            <div className={"select-app " + window.mode}>
                <div className='app-info'>{

                    <i className={
                        "node-icon icon-bsy-" + (type === 'dash' ? 'dash' : !hasCoop ? 'form-flow' : 'form') + " " + icon<=24?"icon-bsy-form-"+icon+"":"icon-new-bsy-form-"+icon+""
                    }></i>
                }

                    <span>{name ? name : React.language('no.set.page')}</span>
                </div>
                <div className='select-btn' onClick={e => { this.onChange() }}>
                    {name ? React.language('change') : React.language('setting')}
                </div>
            </div>
        )
    }
}
export default AlertListSelectApp